import { lightTheme } from "../../themes/lightmode";
import { ThemeProvider } from "@mui/material/styles";
import { Toaster } from "@/app/admin/_common/ui/sonner";

export default function AppThemeProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <ThemeProvider theme={lightTheme}>
      {children}
      <Toaster closeButton position="bottom-right" />
    </ThemeProvider>
  );
}
